var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrendUp = function SvgTrendUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 6h-6a1 1 0 1 0 0 2h5.586l-6.562 6.562a1.45 1.45 0 0 1-2.047 0l-2.539-2.539a3.45 3.45 0 0 0-4.875 0l-4.27 4.27a.999.999 0 1 0 1.414 1.414l4.27-4.27c.547-.547 1.5-.547 2.047 0l2.54 2.539a3.45 3.45 0 0 0 4.874 0l6.563-6.562V15a1 1 0 1 0 2 0V9c0-1.654-1.347-3-3-3"
  })));
};
export default SvgTrendUp;